import { createSlice } from "@reduxjs/toolkit";

const initialOrderReportState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  notificationForEdit: undefined,
  lastError: null,
};
export const callTypes = {
  list: "list",
  action: "action",
};

export const orderReportSlice = createSlice({
  name: "notifications",
  initialState: initialOrderReportState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getNotificationById
    orderReportFetched: (state, action) => {
      state.actionsLoading = false;
      state.notificationForEdit = action.payload.notificationForEdit;
      state.error = null;
    },
    // findNotifications
    orderReportFetched: (state, action) => {
      const { total_items, items } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = items;
      state.totalCount = total_items;
    },
    // allNotifications
    orderReportALlFetched: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.allData = action.payload.allData;
    },
    // createNotification
    // notificationCreated: (state, action) => {
    //   state.ewactionsLoading = false;
    //   state.error = null;
    //   state.entities.push(action.payload.notification);
    // },
    // updateNotification
    orderReportUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map((entity) => {
        if (entity.id === action.payload.notification.id) {
          return action.payload.notification;
        }
        return entity;
      });
    },
  },
});
